"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
/**
 * Creates a collection of essential functions to be used across Zapier
 *
 * Takes a TrackingFunction as an argument and returns additional functions
 * built on top of that function.
 *
 * Example usage:
 *
 * const trackingFunction = (eventType, metaData) => { ... }
 *
 * export const { trackSignupConversion } = createTrackingFunctions(trackingFunction);
 *
 * trackSignupConversion(SignupType.oneTap)
 */
var createTrackingFunctions = function (trackEvent) {
    var trackSignupConversion = function (signupType, metaData) {
        return trackEvent(constants_1.SIGNUP_CONVERSION_EVENT, __assign(__assign({}, metaData), { eventCategory: 'account', eventAction: 'created', eventValue: 1, signupType: signupType }));
    };
    var trackSignupIntent = lodash_1.once(function (signupType, metaData) {
        return trackEvent(constants_1.SIGNUP_INTENT_EVENT, __assign(__assign({}, metaData), { eventCategory: 'account', eventAction: 'created', eventValue: 1, signupType: signupType }));
    });
    var trackBirthEvent = lodash_1.once(function (test, lane, extraEventData) {
        var metaData = __assign(__assign({}, extraEventData), { lane: lane,
            test: test });
        return trackEvent("test: " + test + "_birth", metaData);
    });
    var trackOnce = lodash_1.once(trackEvent);
    return {
        trackEvent: trackEvent,
        trackSignupIntent: trackSignupIntent,
        trackSignupConversion: trackSignupConversion,
        trackBirthEvent: trackBirthEvent,
        trackOnce: trackOnce,
    };
};
exports.default = createTrackingFunctions;
